module.exports = __webpack_public_path__ + "img/icon-scan-qr.3687280b.png";